import { __decorate } from "tslib";
import Vue from 'vue';
import Component from 'vue-class-component';
import pageTitle from '@/router/lang/page-title';
import authItem from '@blade/common/components/auth/auth-item.vue';
let default_1 = class extends Vue {
    hide = true;
    list = [
        {
            title: `${this.$t('roleUserManagement')}`,
            path: '/setting/account',
            code: '0501',
        },
        {
            title: `${this.$t('mapManagement')}`,
            path: '/setting/mapManagement',
            code: '0504',
        },
        {
            title: `${this.$t('deviceManagementPass')}`,
            path: '',
            code: '0503',
            children: [
                {
                    title: `${this.$t('deviceManagement')}`,
                    path: '/setting/deviceManagement',
                    code: '050301',
                },
                {
                    title: `${this.$t('alotManagement')}`,
                    path: '',
                    code: '050302',
                    children: [
                        {
                            title: `${this.$t('deviceManagementPass')}`,
                            path: '/setting/deviceManagementPass',
                            code: '05030201',
                        },
                        {
                            title: `${this.$t('otaManagement')}`,
                            path: '/setting/otaManagement',
                            code: '05030202',
                        },
                        {
                            title: `${this.$t('backgroundManagement')}`,
                            path: '/setting/backgroundManagement',
                            code: '05030203',
                        },
                    ],
                },
                {
                    title: `${this.$t('itsManagement')}`,
                    path: '/setting/itsManagement',
                    code: '050303',
                },
            ],
        },
        // {
        //   title: `${this.$t('alotManagement')}`,
        //   path: '',
        //   code: '0503',
        //   children: [
        //     {
        //       title: `${this.$t('deviceManagementPass')}`,
        //       path: '/setting/deviceManagementPass',
        //       code: '050301',
        //       children: [
        //         {
        //           title: `${this.$t('deviceManagementPass')}`,
        //           path: '/setting/deviceManagementPass',
        //           code: '0503011',
        //         },
        //         {
        //           title: `${this.$t('otaManagement')}`,
        //           path: '/setting/otaManagement',
        //           code: '0503022',
        //         },
        //         {
        //           title: `${this.$t('backgroundManagement')}`,
        //           path: '/setting/backgroundManagement',
        //           code: '0503033',
        //         },
        //       ],
        //     },
        //     {
        //       title: `${this.$t('otaManagement')}`,
        //       path: '/setting/otaManagement',
        //       code: '050302',
        //     },
        //     {
        //       title: `${this.$t('backgroundManagement')}`,
        //       path: '/setting/backgroundManagement',
        //       code: '050303',
        //     },
        //   ],
        // },
        {
            title: `${this.$t('itsManagement')}`,
            path: '/setting/itsManagement',
            code: '0509', // TODO 权限需要变更
        },
        {
            title: `${this.$t('portraitManagement')}`,
            path: '/setting/portraitManagement',
            code: '0506', // TODO 权限需要变更
        },
        {
            title: `${this.$t('portalSettings')}`,
            path: '/setting/portal',
            code: '0502',
        },
        {
            title: `${this.$t('logs')}`,
            path: '/setting/log',
            code: '0505',
        },
        {
            title: `${this.$t('params')}`,
            path: '/setting/params',
            code: '0507',
        },
        {
            title: `${this.$t('attendanceMag')}`,
            path: '/setting/attendanceManagement',
            code: '0508',
        },
    ];
    usWidth = '';
    listIsshow = {
        one: false,
        two: false,
        three: false,
    };
    isGoPage = false;
    mounted() {
        const language = localStorage.getItem('language');
        if (language === 'en-us') {
            this.usWidth = '200px';
        }
        else {
            this.usWidth = '140px';
        }
        document.addEventListener('click', (e) => {
            if (e.target.className !== 'icon icon-settings') {
                this.hideList();
            }
        });
    }
    hideChild() {
        this.listIsshow = {
            one: !this.isGoPage,
            two: false,
            three: false,
        };
    }
    showList() {
        if (this.listIsshow.one) {
            this.listIsshow.one = false;
        }
        else {
            this.isGoPage = false;
            this.listIsshow.one = true;
        }
    }
    changeActive(item, type) {
        if (item.children) {
            this.listIsshow[type] = true;
        }
        else {
            this.listIsshow[type] = false;
        }
    }
    hideList() {
        this.listIsshow = {
            one: false,
            two: false,
            three: false,
        };
    }
    goPage(item) {
        if (item.path) {
            this.isGoPage = true;
            this.hideList();
            this.$router.push(item.path);
        }
    }
    beforeDestroy() {
        document.removeEventListener('click', () => { });
    }
};
default_1 = __decorate([
    Component({
        components: {
            authItem,
        },
        i18n: {
            messages: pageTitle,
        },
    })
], default_1);
export default default_1;
